(function () {
  'use strict';
  const fallback = document.currentScript.dataset.label;
  const selector = 'a.jdgm-popup-card__full-rev-link, a.jdgm-full-rev__product-button';
  function labelLink(link) {
    if (link.textContent.trim() || link.getAttribute('aria-label')) return;
    const label = document.createElement('span');
    label.className = 'visually-hidden';
    const title = link.closest('.jdgm-full-rev')?.getAttribute('data-product-title') ||
      link.closest('.jdgm-popup-card')?.querySelector('.jdgm-popup-card__rev-title')?.textContent.trim();
    label.textContent = title ? fallback + ': ' + title : fallback;
    link.appendChild(label);
  }
  function scan(root) {
    if (root.nodeType !== 1) return;
    if (root.matches(selector)) labelLink(root);
    root.querySelectorAll(selector).forEach(labelLink);
  }
  scan(document.body);
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) scan(node);
  }).observe(document.body, {childList: true, subtree: true});
})();